// extracted by mini-css-extract-plugin
export var closeButton = "_fy-1";
export var closeX = "_fy-3";
export var container = "_fy-0";
export var image = "_fy-2";